/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
$(function() {
  $.closeActionBar = function(e){
    $('.sticky').css('display', 'block');
    location.hash = '';
    if (e && (e.preventDefault != null)) { e.preventDefault(); }
    $('.action-wrapper').curtain('off');
    $('.action-bar-flash .alert').remove();
    $('.action-bar, .action-bar .open').removeClass('open');
    return $('.action-wrapper').addClass('in');
  };

  $.openActionBar = function(target) {
    $('.sticky').css('display', 'none');
    target = $(target); //can be passed selector or element
    if (target.is('.action-pane')) {
      var el = $("a[href=\"#".concat(target.attr('id'), "\"]"));
      $('.action-wrapper').removeClass('in');
      $('.action-bar-flash .alert').remove();
      target.removeClass('in').siblings('.action-pane').addClass('in');
      $('.action-bar').addClass('open').find('.open').removeClass('open');
      el.addClass('open');
      return $('.action-wrapper').curtain('on', $.closeActionBar);
    }
  };

  if (location.hash === '#write_a_review') {
    $('#write-a-review').selectTab();
    $.openActionBar('#review');
  } else if (location.hash.match(/^#review_\d+/)) {
    $.openActionBar('#review');
    $('#reviews').selectTab();
    $('.action-wrapper').scrollTop($('#review.action-pane').find("[id='".concat(location.hash.slice(1), "']")).offset().top);
  } else if (location.hash === '#write_a_comment') {
    $('#write_a_comment').selectTab();
    $.openActionBar('#comment');
  } else if (location.hash.match(/^#comment_\d+/)) {
    $.openActionBar('#comment');
    $('#comments').selectTab();
    $('.action-wrapper').scrollTop($('#comment.action-pane').find("[id='".concat(location.hash.slice(1), "']")).offset().top);
  } else {
    $.openActionBar(location.hash);
  }


  $('.action-wrapper .close').click($.closeActionBar);
  return $('.action-bar a').on('click', function(e){
    e.preventDefault();
    var id = $(this).attr('href');
    var target = $(id);
    location.hash = id;
    if (target.is('.in') || $('.action-wrapper').is('.in')) {
      return $.openActionBar(target);
    } else {
      return $.closeActionBar();
    }
  });
});
